import { render } from "./LoginPage.vue?vue&type=template&id=4653f795&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=4653f795&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4653f795"

export default script